"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _sectionTile = _interopRequireDefault(require("./sectionTile.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // text-align-last: ${unsetTextAlignLast ? 'unset' : 'center'};


var SectionTileWrapper = _styledComponents.default.div.withConfig({
  displayName: "SectionTile__SectionTileWrapper",
  componentId: "uwgxe-0"
})(["margin:", ";border-radius:", ";", " cursor:pointer;background-color:", ";transition:all 0.2s ease-in-out;-ms-grid-column-span:3;-ms-grid-column:", ";-ms-grid-row:", ";text-align:left;width:", ";height:", ";", " ", " & p{outline:none;}", ";", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.space.mini;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius.normal;
}, function (_ref3) {
  var alignCenter = _ref3.alignCenter,
      unsetTextAlignLast = _ref3.unsetTextAlignLast,
      unsetPaddingLeft = _ref3.unsetPaddingLeft;
  return alignCenter ? (0, _styledComponents.css)(["display:flex;padding:", ";align-items:center;justify-content:center;text-align-last:", ";text-align:center;"], function (_ref4) {
    var theme = _ref4.theme;
    return theme.space.small;
  }, unsetTextAlignLast ? 'unset' : 'center') : (0, _styledComponents.css)(["padding:", ";text-align:left;padding-left:", ";"], function (_ref5) {
    var theme = _ref5.theme;
    return theme.space.small;
  }, unsetPaddingLeft && "0px");
}, function (_ref6) {
  var theme = _ref6.theme,
      backgroundColor = _ref6.backgroundColor;
  return theme.backgroundColor[backgroundColor];
}, function (_ref7) {
  var gridCol = _ref7.gridCol;
  return gridCol;
}, function (_ref8) {
  var gridRow = _ref8.gridRow;
  return gridRow;
}, function (_ref9) {
  var width = _ref9.width;
  return width || 'auto';
}, function (_ref10) {
  var height = _ref10.height;
  return height || 'auto';
}, function (_ref11) {
  var minHeight = _ref11.minHeight;
  return minHeight && (0, _styledComponents.css)(["min-height:", ";"], minHeight);
}, function (_ref12) {
  var enableHover = _ref12.enableHover;
  return enableHover && (0, _styledComponents.css)(["&:hover{background-color:", ";}"], function (_ref13) {
    var theme = _ref13.theme,
        hoverBackgroundColor = _ref13.hoverBackgroundColor;
    return theme.backgroundColor[hoverBackgroundColor];
  });
}, function (_ref14) {
  var theme = _ref14.theme,
      borderColor = _ref14.borderColor,
      active = _ref14.active;
  return borderColor && (0, _styledComponents.css)(["border:1px solid ", ";"], active ? 'transparent' : theme.colors[borderColor]);
}, function (_ref15) {
  var theme = _ref15.theme,
      active = _ref15.active,
      defaultBorderColor = _ref15.defaultBorderColor,
      activeBackGroundColor = _ref15.activeBackGroundColor,
      backgroundColor = _ref15.backgroundColor;
  return active ? (0, _styledComponents.css)(["box-shadow:0 0 0 1px ", ";background-color:", ";"], function (_ref16) {
    var activeBorderColor = _ref16.activeBorderColor;
    return theme.colors[activeBorderColor];
  }, theme.colors[activeBackGroundColor] || 'none') : defaultBorderColor && (0, _styledComponents.css)(["background-color:", ";box-shadow:0 0 0 1px ", ";"], theme.backgroundColor[backgroundColor], theme.colors[defaultBorderColor]);
}, function (_ref17) {
  var center = _ref17.center;
  return center && (0, _styledComponents.css)(["display:flex;flex-direction:column;align-items:center;justify-content:center;"]);
});

var SectionTile = function SectionTile(props) {
  var title = props.title,
      value = props.value,
      titleColor = props.titleColor,
      subtitle = props.subtitle,
      subtitleColor = props.subtitleColor,
      subtitleTextAlign = props.subtitleTextAlign,
      subtitleType = props.subtitleType,
      titleType = props.titleType,
      backgroundColor = props.backgroundColor,
      hoverBackgroundColor = props.hoverBackgroundColor,
      active = props.active,
      activeTitleColor = props.activeTitleColor,
      activeBackGroundColor = props.activeBackGroundColor,
      activeBorderColor = props.activeBorderColor,
      defaultBorderColor = props.defaultBorderColor,
      onClick = props.onClick,
      accessible = props.accessible,
      customProperties = props.customProperties,
      theme = props.theme,
      enableHover = props.enableHover,
      minHeight = props.minHeight,
      alignCenter = props.alignCenter,
      unsetTextAlignLast = props.unsetTextAlignLast,
      unsetPaddingLeft = props.unsetPaddingLeft,
      index = props.index,
      center = props.center,
      width = props.width,
      height = props.height,
      borderColor = props.borderColor,
      activeSubtitleColor = props.activeSubtitleColor,
      toggleOnClick = props.toggleOnClick,
      disableActiveState = props.disableActiveState,
      bold = props.bold;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var tabIndex = !accessible ? '-1' : '0';

  var _React$useState = _react.default.useState(disableActiveState ? false : active),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      activeTab = _React$useState2[0],
      setActiveTab = _React$useState2[1];

  var gridCol = index * 3;
  gridCol += 1;
  (0, _react.useEffect)(function () {
    if (!disableActiveState) {
      setActiveTab(active);
    }
  }, [active, disableActiveState]);
  var rowFloor = Math.floor(gridCol / 12);
  var gridRow = rowFloor + 1;
  gridCol -= rowFloor * 12;

  var clickHandler = function clickHandler() {
    if (toggleOnClick) {
      onClick(value, !activeTab);

      if (!disableActiveState) {
        setActiveTab(!activeTab);
      }
    } else {
      onClick(value, true);

      if (!disableActiveState) {
        setActiveTab(true);
      }
    }
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(SectionTileWrapper, (0, _extends2.default)({
      tabIndex: tabIndex,
      minHeight: minHeight,
      backgroundColor: backgroundColor,
      hoverBackgroundColor: hoverBackgroundColor,
      active: activeTab,
      alignCenter: alignCenter,
      unsetTextAlignLast: unsetTextAlignLast,
      unsetPaddingLeft: unsetPaddingLeft,
      activeBorderColor: activeBorderColor,
      onClick: clickHandler,
      onKeyDown: function onKeyDown(e) {
        return _utilities.default.keyDownHandler(e, clickHandler, _constant.KEY_CODE.ENTER);
      },
      activeBackGroundColor: activeBackGroundColor,
      defaultBorderColor: defaultBorderColor,
      enableHover: enableHover,
      gridCol: gridCol,
      gridRow: gridRow,
      width: width,
      height: height,
      borderColor: borderColor,
      center: center
    }, customProperties), /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: !activeTab ? titleColor : activeTitleColor,
      display: "block",
      bold: true,
      textAlign: center || (alignCenter ? 'center' : ''),
      accessible: false,
      theme: theme,
      type: titleType
    }, title), subtitle && /*#__PURE__*/_react.default.createElement(_Text.default, {
      color: active ? activeSubtitleColor : subtitleColor,
      display: "block",
      accessible: false,
      theme: theme,
      bold: bold,
      textAlign: subtitleTextAlign,
      type: subtitleType
    }, subtitle));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

SectionTile.propTypes = _sectionTile.default.PropTypes;
SectionTile.defaultProps = _sectionTile.default.DefaultProps;
var _default = SectionTile;
exports.default = _default;